var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404 - Halaman Tidak Ditemukan")]),_c('p',[_vm._v("Oops! Halaman yang kamu cari tidak tersedia.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Kembali ke Beranda")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }